import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/6.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';


import res1 from '../assets/photos/real_estate/1.jpg';
import res2 from '../assets/photos/real_estate/2.jpg';
import res3 from '../assets/photos/real_estate/3.jpg';
import res4 from '../assets/photos/real_estate/4.jpg';
import res5 from '../assets/photos/real_estate/5.jpg';
import res6 from '../assets/photos/real_estate/6.jpg';
import res7 from '../assets/photos/real_estate/7.jpg';
import res8 from '../assets/photos/real_estate/8.jpg';
import res9 from '../assets/photos/real_estate/9.jpg';
import res10 from '../assets/photos/real_estate/10.jpg';
import res11 from '../assets/photos/real_estate/11.jpg';
import res12 from '../assets/photos/real_estate/12.jpg';
import res13 from '../assets/photos/real_estate/13.jpg';
import res14 from '../assets/photos/real_estate/14.jpg';
import res15 from '../assets/photos/real_estate/15.jpg';
import res16 from '../assets/photos/real_estate/16.jpg';
import res17 from '../assets/photos/real_estate/17.jpg';
import res18 from '../assets/photos/real_estate/18.jpg';
import res19 from '../assets/photos/real_estate/19.jpg';
import res20 from '../assets/photos/real_estate/20.jpg';
import res21 from '../assets/photos/real_estate/21.jpg';
import res22 from '../assets/photos/real_estate/22.jpg';
import res23 from '../assets/photos/real_estate/23.jpg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											REAL ESTATE SOLUTIONS
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">
								<img
									src={realestate_pic}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "18px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									We provide comprehensive real estate solutions designed to enhance both the functionality and beauty of residential, commercial, and hospitality spaces. From premium sanitary fittings to custom-designed interiors, we combine modern designs with durable materials to bring your vision to life. Whether you are building, renovating, or upgrading, our solutions cover every corner — inside and out.
								</h6>

								<HorizontalImageStrip
									images={[res1, res2, res3, res4, res5]}
								/>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									Sanitary Solutions
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={res2}
								/>		


								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Enhance comfort and hygiene with our premium sanitary products:
									<br/>

									1) Toilets, bidets & urinals <br/>
									2) Wash basins, vanity units & mirrors <br/>
									3) Bathtubs, jacuzzis & shower cabins <br/>
									4) Faucets, mixers & bathroom accessories <br/>
									5) Water heaters & instant heaters <br/>
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									Indoor Solutions
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={res6}
								/>		


								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Create warm and functional indoor spaces:
									<br/>

									1) Interior doors (wood, glass, aluminum) <br/>
									2) Floor finishes: ceramic, marble, wood, and laminate <br/>
									3) Ceiling & wall designs (false ceilings, paneling, wallpaper) <br/>
									4) Indoor lighting fixtures & chandeliers <br/>
									5) Window treatments (curtains & blinds) <br/>
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									Outdoor Solutions
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={res5}
								/>		


								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Add beauty and durability to your exterior spaces:
									<br/>

									1) Exterior doors & security gates <br/>
									2) Outdoor flooring (paving stones, tiles, decking) <br/>
									3) Exterior lighting <br/>
									4) Landscaping materials (artificial grass, stones, planters) <br/>
									5) Pergolas, gazebos & fencing <br/>
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									Aluminum & Glass Works
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={res10}
								/>		


								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Modern, stylish, and functional installations:
									<br/>
									1) Aluminum windows & sliding doors <br/>
									2) Glass partitions & shower screens <br/>
									3) Glass railings, balustrades & façades <br/>
									4) Skylights & curtain wall systems <br/>
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									Kitchen & Wardrobe Solutions
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={res18}
								/>		


								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Functional spaces tailored to your needs:
									<br/>
									1) Modular kitchens with premium finishes<br/>
									2) Custom kitchen cabinets & countertops<br/>
									3) Walk-in wardrobes & sliding wardrobes<br/>
									4) Built-in storage solutions<br/>
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									Interior & Exterior Design Services
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={res22}
								/>		


								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Transform spaces into timeless works of art:
									<br/>
									1) Space planning & 3D visualization<br/>
									2) Furniture design & sourcing<br/>
									3) Color, lighting & material consultancy<br/>
									4) Garden, landscape & pool design<br/>
									5) Outdoor furniture & décor<br/>
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									Additional Solutions (optional add-ons)
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={res12}
								/>		


								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									1) Smart home & security systems <br/>
									2) Solar energy solutions <br/>
									3) Staircases & railing design <br/>
									4) Wall cladding & façade finishes <br/>
									5) Acoustic soundproofing <br/>
								</h6>
							</div>

							
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}